import { Nighthaunt } from "whole-shared";

import type { ClientAosFaction } from "./factions";

export const ClientNighthaunt: ClientAosFaction = { ...Nighthaunt, name: "NIGHTHAUNT" };
